import { useQuery } from '@tanstack/react-query';
import { defaultParamsSerializer, handleApiResponse } from '@/functions';
import { apiClient } from '@/components/api';
import { Paginated } from '@/lib/interface';
import routes from '@/lib/routes';
import type { IBulkNotificationCampaign, IGetBulkNotificationCampaignsParams } from '@/interfaces';

export const useRequestGetBulkNotificationCampaigns = (
	params: IGetBulkNotificationCampaignsParams = {},
) => {
	const { isFetching, data, error } = useQuery({
		queryKey: [routes.api.bulkNotificationCampaigns.base, params],
		queryFn: () =>
			apiClient
				.get<Paginated<IBulkNotificationCampaign>>(
					routes.api.bulkNotificationCampaigns.base,
					params,
					{ paramsSerializer: defaultParamsSerializer },
				)
				.then(handleApiResponse),
		staleTime: 30_000,
	});

	return {
		isLoading: isFetching,
		campaigns: data?.data ?? [],
		pagination: data?.pagination,
		error,
	};
};
